import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  branchOfficeMlsProvider: null,
  branchOfficeMlsProviders: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const branchOfficeMlsProviderReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.BRANCHOFFICEMLSPROVIDER_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.BRANCHOFFICEMLSPROVIDER_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.BRANCHOFFICEMLSPROVIDER_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default branchOfficeMlsProviderReducer;
